'use strict';

var _tslib = require('./_tslib-17936c8d.js');
var React = require('react');
var styles = require('./styles-2eec2580.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var ArrowDown = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? styles.themeColors.gray[50] : _b, props = _tslib.__rest(_a, ["fill"]);
    return (React__namespace.createElement("svg", _tslib.__assign({ className: props.className, width: "24", height: "24", viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg" }, props),
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.293 15.7072L6.00008 10.4143C5.60955 10.0238 5.60955 9.3906 6.00008 9.00008C6.3906 8.60955 7.02376 8.60955 7.41429 9.00007L12.0001 13.5859L16.5859 9.00008C16.9764 8.60955 17.6096 8.60955 18.0001 9.00008C18.3906 9.3906 18.3906 10.0238 18.0001 10.4143L12.7072 15.7072C12.3167 16.0977 11.6835 16.0977 11.293 15.7072Z" })));
};

exports.ArrowDown = ArrowDown;
//# sourceMappingURL=ArrowDown-74f74169.js.map
